import { Card } from "@/components/containers/Card";
import HorizontalScrollList from "@/components/containers/HorizontalScrollList";
import SectionTitle from "@/components/misc/SectionTitle";
import { Text } from "@/components/text/Text";
import { useLanguageContext } from "@/context/LanguageContext";
import { useTimmaContext } from "@/context/TimmaContext";
import { useMediaQuery, useTheme } from "@mui/material";
import React, { useMemo } from "react";

const AboutUs: React.FC = () => {
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));

  const { workers } = useTimmaContext();

  const { lang } = useLanguageContext();

  const sortedWorkers = useMemo(() => {
    if (!workers) return [];
    return [...workers].sort((a, b) => {
      if (a.nickName.toLowerCase() === "juanita") return -1;
      if (b.nickName.toLowerCase() === "juanita") return 1;
      return a.nickName.localeCompare(b.nickName);
    });
  }, [workers]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        paddingTop: "20px",
        paddingBottom: "20px",
      }}
    >
      <SectionTitle title={lang.t("landing.aboutUs.title")}>
        <Text>
          {lang.t("landing.aboutUs.descriptionLine1")}
          <br />
          {lang.t("landing.aboutUs.descriptionLine2")}
        </Text>
      </SectionTitle>
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
        }}
      >
        {isMobile ? (
          <HorizontalScrollList
            items={sortedWorkers}
            renderItem={(worker) => (
              <Card
                source={worker.imageUrl}
                key={worker.id}
                style={{ width: "80%", margin: "0 10px" }}
                imageStyle={{ width: "100%" }}
              >
                <Text type="p" size="large" style={{ textAlign: "center" }}>
                  {worker.nickName}
                </Text>
                <Text
                  type="p"
                  size="small"
                  style={{ textAlign: "center", margin: 0 }}
                >
                  {worker.title}
                </Text>
                <Text type="p" size="small" style={{ textAlign: "center" }}>
                  ({worker.services.length}{" "}
                  {lang.t("landing.aboutUs.numOfServicesText")})
                </Text>
              </Card>
            )}
            keyExtractor={(worker) => worker.id.toString()}
            fullScreenItems
            hideScrollBar
            navigationSettings={{
              show: true,
              panel: {
                position: "inside",
                visibility: "visible",
              },
            }}
          />
        ) : (
          <>
            {sortedWorkers.map((worker) => (
              <Card
                source={worker.imageUrl}
                key={worker.id}
                style={{ width: "20%" }}
                imageStyle={{ width: "100%" }}
              >
                <Text type="p" size="large" style={{ textAlign: "center" }}>
                  {worker.nickName}
                </Text>
                <Text
                  type="p"
                  size="small"
                  style={{ textAlign: "center", margin: 0 }}
                >
                  {worker.title}
                </Text>
                <Text type="p" size="small" style={{ textAlign: "center" }}>
                  ({worker.services.length}{" "}
                  {lang.t("landing.aboutUs.numOfServicesText")})
                </Text>
              </Card>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default AboutUs;
